import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { UIActions } from './uiActions/UIActions';

export interface NavTelemetryEventEmitterProps {
  readonly uiActions: UIActions;
}

type NavTelemetryEventEmitterInternalProps = NavTelemetryEventEmitterProps & RouteComponentProps;

type HistoryLocation = RouteComponentProps['location'];

function locationHasChanged(prevLocation: HistoryLocation, newLocation: HistoryLocation): boolean {
  return prevLocation.pathname !== newLocation.pathname || prevLocation.search !== newLocation.search;
}

function locationToString(location: HistoryLocation) {
  return `${location.pathname}${location.search}`;
}

class NavTelemetryEventEmitterInternal extends React.Component<NavTelemetryEventEmitterInternalProps> {
  private prevLocation: HistoryLocation = this.props.history.location;
  private unlisten: () => void = () => undefined;

  public override componentDidMount() {
    this.unlisten = this.props.history.listen((location) => {
      if (locationHasChanged(this.prevLocation, location)) {
        this.props.uiActions.sendNavigationTelemetryEvent(locationToString(this.prevLocation), locationToString(location));
      }
      this.prevLocation = location;
    });
  }

  public override componentWillUnmount() {
    this.unlisten();
  }

  public override render() {
    return null;
  }
}

export const NavTelemetryEventEmitter = withRouter(NavTelemetryEventEmitterInternal);
